/// <reference path="./@types/global.d.ts" />
import React from "react";
import ReactDOM from "react-dom";
import Pages from "./Pages";
import reportWebVitals from "./reportWebVitals";
import { UserStateProvider } from "./hooks";


import 'antd/dist/antd.css'
import "./index.css";

ReactDOM.render(
    <React.StrictMode>
        <UserStateProvider>
            <Pages />
        </UserStateProvider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
